import React from 'react';
import Home from './components/Home/Home';
import './assets/styles/App.scss';

const App = () => {
  return (
    <div className="App">
      <Home />
    </div>
  );
};

export default App; 